// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-sjhmhz-index-main_right_content-2I35c","table":"components-tjcx-sjhmhz-index-table-v-4p_"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/sjhmhz/index.css
// module id = 2317
// module chunks = 0